import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ContactDetails  {
    _originalTypeClassName = "zSHR.BO.ContactDetails";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ContactDetails.translate = translateService;
}
this.Id = null;
this.Name = null;
this.PhoneNumber = null;
this.MobilePhoneNumber = null;
this.Email = null;
this.IsDefault = false;
this.SkypeUsername = null;
this.Fax = null;
this.DepartmentName = null;
this.BusinessPhone = null;
this.InternalPhone = null;
this.EmailBusiness = null;
this.DepPosTitle = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
PhoneNumber:any;
MobilePhoneNumber:any;
Email:any;
IsDefault:any;
SkypeUsername:any;
Fax:any;
DepartmentName:any;
BusinessPhone:any;
InternalPhone:any;
EmailBusiness:any;
DepPosTitle:any;


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}